import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from "../Helpers";

export const reducerName = 'weatherState';

export const getAllWeather = createAsyncThunk(
    'weatherState/getAllWeather',
    async (_, { getState, rejectWithValue }) => {
        let tempsList = [];
        
        const coordinates = getState().deviceState.activeDevice.coordinates;

        if (coordinates !== undefined) {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `${config.server}/api/dmi?coords=${coordinates}`,
                    withCredentials: true,
                    auth: createAuth(getState)
                });

                var dates = response.data.domain.axes.t.values;
                var kelvinTemps = response.data.ranges['temperature-0m'].values;
                var windspeed = response.data.ranges['wind-speed'].values;
                var nedbor = response.data.ranges['total-precipitation'].values;
                var cloudcover = response.data.ranges['fraction-of-cloud-cover'].values;

                for (let i = 0; i < dates.length; i++) {
                    let celsiusTemp = kelvinTemps[i] - 273.15;
                    let object = {
                        dateTime: dates[i],
                        temp: celsiusTemp,
                        wind: windspeed[i],
                        nedbor: nedbor[i],
                        cloudcover: cloudcover[i],
                    };
                    tempsList.push(object);
                }

                return tempsList;
            } catch (error) {
                console.error('ERROR FETCHING Weather', error);
                return rejectWithValue(error.response?.data || 'An error occurred');
            }
        }
        return [];
    }
);

const initialState = {
    temps: [],
    hasWeatherData: false,
    status: 'idle',
    error: null,
};

const weatherSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getAllWeather
            .addCase(getAllWeather.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllWeather.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.hasWeatherData = true;
                state.temps = action.payload;
            })
            .addCase(getAllWeather.rejected, (state, action) => {
                state.status = 'failed';
                state.hasWeatherData = false;
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default weatherSlice.reducer;